module.exports = __webpack_public_path__ + "static/media/3 Way Left.e64f50fe.png";